import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles(theme => ({
  imagesContainer: {
    maxHeight: '320px',
    overflow: 'auto',
  },
  imageWrapper: {
    position: 'relative',
    padding: '1px 4px',
  },
  imageLabel: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '100%',
  },
  image: {
    objectFit: 'cover',
    width: 140,
    height: 140,
    border: '1px solid whitesmoke',
  },
  selectionOverlay: {
    position: 'absolute',
    width: 20,
    height: 20,
    top: 10,
    right: 10,
    backgroundColor: '#fff',
    borderRadius: '50%',
    border: '1.25px solid #fff',
  },
  currentImgWrapper: {
    position: 'relative',
    width: 140,
    height: 140,
  },
  deleteButton: {
    position: 'absolute',
    top: -8,
    right: -8,
    backgroundColor: '#fff',
    zIndex: 2,
    boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  imgUpload: {
    padding: '0.3rem 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    border: '1px solid whitesmoke',
  },
  error: {
    fontSize: '0.875rem',
    color: '#2E7C86',
    textAlign: 'center',
    marginTop: 15,
    marginBottom: 0,
  },
}))
